<template>
    <a-collapse id="dd-collapse" expandIconPosition="right" v-bind="$attrs" @change="(arg) => $emit('change', arg)">
      <template v-slot:expandIcon="props">
        <ChevronDownIcon
          id="expandIcon"
          class="icon-size-lg fill-primary mr-sm"
          :class="{active: props.isActive}"
        />
      </template>
      <slot></slot>
    </a-collapse>
</template>

<script>
export default {
  name: "Collapse",
}
</script>

<style lang="scss">
@import '~@/_default.scss';
#dd-collapse{
  border-radius: $border-radius-base;

  .inactive .ant-collapse-header{
    color: $brand-danger !important;
  }
  .ant-collapse-header{
    font-weight: 500;
    font-size: $font-size-base;
    color: $color-primary;
  }
  .ant-collapse-item:last-child, .ant-collapse-content:last-child{
    border-bottom-left-radius: $border-radius-base;
    border-bottom-right-radius: $border-radius-base;
  }
  #expandIcon svg{
    transition: all 0.2s ease-in-out !important;
  }
  #expandIcon.active svg{
    transform: rotate(180deg) !important;
  }
}
</style>